import React from 'react'
import { Link } from "react-router-dom";
import CompanyLogo from "../Images/CompanyLogo.png";
import TeacherBlue from "../Images/TeacherBlue.png";

const Header = () => {
  return (
    <div className='headerSpace'>
      <div className='header' id="top">
        <div className='headerSection'>
          <Link to="/#top" className='' style={{ textDecoration: 'none' }}>
            <img src={CompanyLogo} className="CompanyLogo" alt="" />
          </Link>
          <div className='headerLinks'>
            <Link to="/teacher" className='toTeacher' style={{ textDecoration: 'none' }}>
              <img src={TeacherBlue} alt="" />
              <p>家庭教師の方はこちら</p>
            </Link>
            <Link to="/registration-student" className='toStudentRegistration pcArea' style={{ textDecoration: 'none' }}>
            <p>生徒情報を登録する</p>
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Header